import React, { useEffect, useState } from "react";
import "../style/component/profile.css";
import CrownIcon from "../assets/image/crown.svg";
import TutorialIcon from "../assets/image/tutorial.svg";
import PhoneIcon from "../assets/image/phone.svg";
import WalletIcon from "../assets/image/wallets.svg";
import GiftIcon from "../assets/image/gift.svg";
// import EarnCoinsIcon from "../assets/image/earncoins.svg";
import IdeasIcon from "../assets/image/ideas.svg";
import FortuneWheelIcon from "../assets/image/fortune-wheel.svg";
import InsightIcon from "../assets/image/insight.svg";
import HelpIcon from "../assets/image/help.svg";
import LogoutIcon from "../assets/image/logout.svg";
import {
  LevelPreviewModal,
  LogoutModal,
  RatingModal,
} from "../utils/modal";
import { Link, useLocation, useNavigate } from "react-router-dom";
import RightArrow from "../assets/image/right-arrow-white.svg";
import { useDispatch, useSelector } from "react-redux";
import MenuProfile from "../assets/image/menu-profile-img.png";
import ProfileBadge from "../assets/image/badge-icon-1a.png";
import PremiumBadge from "../assets/image/premium-badge.png";
import { Postdata } from "../utils/api.services";
import HttpService from "../utils/https.services";
import { clearTourStateForUser } from "../utils/tourStorage.js";
import { toast } from "react-toastify";
import { loginClear } from "../redux/actions/auth.action";
import { RakutenListSuccess } from "../redux/actions/rakuten/rakuten.action";
import {
  ProfileImage,
  getUserData,
  UpdatedData,
} from "../redux/selectors/selector";
import StaticProfileImage from "../assets/image/avatar-img.png";
import Joyride from "react-joyride";
import Tour from "./tour";
import { EVENTS, trackEvent } from "../component/mixpanel";
import { AF_EVENTS, trackAFEvent } from "../component/appsflyer";
import { showProfileSideMenu } from "../utils/profileMenuNavigation";

const ProfileSideMenu = () => {
  const [isModalActive, setModalActive] = useState(false);
  const [isRatingModalActive, setRatingModalActive] = useState(false);
  const [isLevelModalActive, setLevelModalActive] = useState(false);
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [currentLevel, setCurrentLevel] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const UserData = useSelector(UpdatedData);
  const getProfile = useSelector(ProfileImage);
  const [firstInsight, setFirstInsight] = useState("");
  const [firstCMS, setFirstCMS] = useState("");

  const TourStyle = {};

  const steps = [
    {
      target: ".empty-step",
    },
    {
      target: ".profile-sidemenu-header",
      content:
        "Check your profile here for badges, achievements, and settings. Manage your account and personalize your experience.",
    },
    {
      target: ".profile-sidemenu li:nth-child(7)", // Quiz
      content:
        "Interactive quizzes designed to test and enhance financial knowledge and trading strategies.",
    },
    {
      target: ".profile-sidemenu li:nth-child(5)", // Shop
      content:
        'Explore the Rally Bulls Store by clicking "Shop" in the navigation menu, browse and view item details, and use Rally Coins to redeem items.',
    },
    {
      target: ".profile-sidemenu li:nth-child(8)", // Spin Wheel
      content:
        "A gamified reward system where users spin to win prizes and incentives.",
    },
  ];
  useEffect(() => {
    FetchInsightsModule();
    FetchCMSModule();
  }, []);

  const FetchInsightsModule = () => {
    Postdata(HttpService()?.inSights)
      .then((result) => {
        if (result?.status && result?.data.length > 0) {
          console.log(101, result);
          setFirstInsight(result?.data[0]?.page_code);
          // setInsights(result?.data);
        } else {
          // toast.error(result?.message);
        }
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message);
      });
  };

  const FetchCMSModule = () => {
    Postdata(HttpService()?.cms)
      .then((result) => {
        if (result?.status && result?.data.length > 0) {
          setFirstCMS(result?.data[0]?.page_code);
        } else {
          // toast.error(result?.message);
        }
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message);
      });
  };

  const openModal = () => {
    setModalActive(true);
  };

  const closeModal = () => {
    setModalActive(false);
  };

  const openLevelModal = (level) => {
    setCurrentLevel(level);
    setLevelModalActive(true);
  };

  const closeLevelModal = () => {
    setLevelModalActive(false);
  };

  const closeRatingModal = () => {
    setRatingModalActive(false);
  };

  const isActive = (path) => {
    const { pathname } = location;
    return pathname === path || pathname.startsWith(`${path}/`);
  };

  const logouthandler = () => {
    Postdata(HttpService()?.logout)
      .then((result) => {
        if (result.status) {
          toast.success(result?.message);
          clearTourStateForUser(UserData?._id);
          localStorage.removeItem("hasSeenTour");
          localStorage.removeItem("giveProfileChance");
          dispatch(loginClear(result));
          dispatch(RakutenListSuccess([]));
          localStorage.removeItem("ProfileImage");
          navigate("/");
        } else {
          toast.error(result.message);
        }
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message);
      });
  };

  return (
    <div className="profile-sidemenu-wrap profile-sidemenu-joyride">
      {/* {location.pathname === "/home/profile" && (
        <Tour
          steps={steps}
          isOpen={isTourOpen}
          onRequestClose={() => setIsTourOpen(false)}
        />
      )} */}
      <div className="profile-sidemenu-header">
        <div
          className="profile-sidemenu-user-row d-flex align-items-start cursor-pointer"
          onClick={() => navigate("/home/profile")}
        >
          <div className="user-img">
            <img
              src={getProfile ? getProfile : StaticProfileImage}
              alt="MenuProfile"
            />
            <div className="icon-wrap">
              <img src={ProfileBadge} alt="Badge" />
            </div>
          </div>
          <div className="user-info">
            <h6>{UserData.username ? UserData.username : "Guest User"}</h6>
            <p
              onClick={(e) => {
                e.stopPropagation();
                openLevelModal(UserData?.level ? UserData?.level : 0);
              }}
            >
              Level - {UserData?.level ? UserData?.level : 0}
            </p>
          </div>
          <span className="header-nav-chevron">
            <img src={RightArrow} alt="" />
          </span>
        </div>
        <div className="profile-sidemenu-plan">
          <p>
            Current Plan:{" "}
            <strong>{UserData?.subscription?.name || "FREE"}</strong>
          </p>
          <Link to="/home/profile/plus" className="sidemenu-upgrade-btn">
            Upgrade
          </Link>
        </div>
      </div>
      <div className="profile-sidemenu">
        <ul>
          <li
            className={`subscription-item${
              isActive("/home/profile/plus") ? " active" : ""
            }`}
          >
            <div className="profile-menu-box d-flex align-items-center">
              <div className="icon-wrap">
                <img src={CrownIcon} alt="Subscription" />
              </div>
              <div className="prof-menu-box-info">
                <Link to="/home/profile/plus">
                  <h6>Subscription</h6>
                  <p>Unlock Premium Benefits</p>
                </Link>
              </div>
              <img src={RightArrow} alt="" className="menu-item-chevron" />
            </div>
          </li>
          <li className={isActive("/home/profile/tutorial") ? "active" : ""}>
            <div className="profile-menu-box d-flex align-items-center">
              <div className="icon-wrap">
                <img src={TutorialIcon} alt="Tutorials" />
              </div>
              <div className="prof-menu-box-info">
                <Link to="/home/profile/tutorial">
                  <h6>Tutorials</h6>
                  <p>Guided Tutorials for Every Feature</p>
                </Link>
              </div>
            </div>
          </li>
          <li className={isActive("/home/profile/contact-us") ? "active" : ""}>
            <div className="profile-menu-box d-flex align-items-center">
              <div className="icon-wrap">
                <img src={PhoneIcon} alt="Contact Us" />
              </div>
              <div className="prof-menu-box-info">
                <Link to="/home/profile/contact-us">
                  <h6>Contact Us</h6>
                  <p>Reach Out to Our Team</p>
                </Link>
              </div>
            </div>
          </li>
          <li className={isActive("/home/profile/wallet") ? "active" : ""}>
            <div className="profile-menu-box d-flex align-items-center">
              <div className="icon-wrap">
                <img src={WalletIcon} alt="Wallet" />
              </div>
              <div className="prof-menu-box-info">
                <Link
                  to="/home/profile/wallet"
                  onClick={() => showProfileSideMenu()}
                >
                  <h6>Wallet</h6>
                  <p>View your Rally Coins Balance</p>
                </Link>
              </div>
            </div>
          </li>
          <li className={isActive("/home/profile/shop") ? "active" : ""}>
            <div className="profile-menu-box d-flex align-items-center">
              <div className="icon-wrap">
                <img src={GiftIcon} alt="Shop" className="menu-icon-shop" />
              </div>
              <div className="prof-menu-box-info">
                <Link
                  to="/home/profile/shop"
                  onClick={() => {
                    showProfileSideMenu();
                    trackAFEvent(AF_EVENTS.MP_SHOP_CLICK, {
                      section: "clicked",
                      action: "click_shop",
                    });

                    trackEvent(EVENTS.MP_SHOP_CLICK, {
                      section: "clicked",
                      action: "click_shop",
                    });
                  }}
                >
                  <h6>Shop</h6>
                  <p>Redeem your Rally Coins</p>
                </Link>
              </div>
            </div>
          </li>
          {/* Earn Coins section hidden for now
          <li className={isActive("/home/profile/earn") ? "active" : ""}>
            <div className="profile-menu-box d-flex align-items-center">
              <div className="icon-wrap">
                <img src={EarnCoinsIcon} alt="Earn Coins" />
              </div>
              <div className="prof-menu-box-info">
                <Link
                  to="/home/profile/earn/coin"
                  onClick={() =>
                    trackEvent(EVENTS.MP_EARNCOIN_CLICK, {
                      section: "clicked",
                      action: "click_EarnCoin",
                    })
                  }
                >
                  <h6>Earn Coins</h6>
                  <p>Watch Ads and Earn Rally Coins</p>
                </Link>
              </div>
            </div>
          </li>
          */}
          <li className={isActive("/home/quiz") ? "active" : ""}>
            <div className="profile-menu-box d-flex align-items-center">
              <div className="icon-wrap">
                <img src={IdeasIcon} alt="Quiz" />
              </div>
              <div className="prof-menu-box-info">
                <Link
                  to="/home/quiz"
                  onClick={() => {
                    trackAFEvent(AF_EVENTS.MP_QUIZ, {
                      section: "clicked",
                      action: "click_quiz",
                    });

                    trackEvent(EVENTS.MP_QUIZ, {
                      section: "clicked",
                      action: "click_quiz",
                    });
                  }}
                >
                  <h6>Quiz</h6>
                  <p>Test your Market Knowledge</p>
                </Link>
              </div>
            </div>
          </li>
          <li className={isActive("/home/profile/spin-wheel") ? "active" : ""}>
            <div className="profile-menu-box d-flex align-items-center">
              <div className="icon-wrap">
                <img src={FortuneWheelIcon} alt="Spin Wheel" />
              </div>
              <div
                className="prof-menu-box-info"
                onClick={() => window.location.reload()}
              >
                <Link
                  to="/home/profile/spin-wheel"
                  onClick={() => {
                    trackAFEvent(AF_EVENTS.MP_SPINWHEEL_CLICK, {
                      section: "clicked",
                      action: "click_spinWheel",
                    });

                    trackEvent(EVENTS.MP_SPINWHEEL_CLICK, {
                      section: "clicked",
                      action: "click_spinWheel",
                    });
                  }}
                >
                  <h6>Spin Wheel</h6>
                  <p>Spin and Win Rally Coins</p>
                </Link>
              </div>
            </div>
          </li>
          <li
            className={isActive("/home/profile/insights") ? "active" : ""}
          >
            <div className="profile-menu-box d-flex align-items-center">
              <div className="icon-wrap">
                <img src={InsightIcon} alt="Insights" />
              </div>
              <div className="prof-menu-box-info">
                <Link to={`/home/profile/insights/${firstInsight}`}>
                  <h6>Rally Bulls Insights</h6>
                  <p>Market Insights and Updates</p>
                </Link>
              </div>
            </div>
          </li>
          <li className={isActive("/home/profile/setting") ? "active" : ""}>
            <div className="profile-menu-box d-flex align-items-center">
              <div className="icon-wrap">
                <img src={HelpIcon} alt="Help Center" />
              </div>
              <div className="prof-menu-box-info">
                <Link to={`/home/profile/setting/${firstCMS}`}>
                  <h6>Help Center</h6>
                  <p>Support, FAQs, and Resources</p>
                </Link>
              </div>
            </div>
          </li>
          <li>
            <div className="profile-menu-box d-flex align-items-center cursor-pointer" onClick={openModal}>
              <div className="icon-wrap">
                <img src={LogoutIcon} alt="Log Out" />
              </div>
              <div className="prof-menu-box-info">
                <h6>Log Out</h6>
                <p>Sign Out Securely</p>
              </div>
            </div>
          </li>
        </ul>
        <LogoutModal
          isActive={isModalActive}
          onClose={closeModal}
          onClick={logouthandler}
        />
        <RatingModal
          isActive={isRatingModalActive}
          onClose={closeRatingModal}
        />
        <LevelPreviewModal
          isActive={isLevelModalActive}
          onClose={closeLevelModal}
          level={currentLevel}
        />
        {/* <SocialShare
          isActive={isopenShareModal}
          onClose={closeShareModal}
          referalData = {UserData?.referral_code}
          name = {UserData?.username}
        /> */}
      </div>
    </div>
  );
};

export default ProfileSideMenu;
